import { AxiosInstance } from 'axios';
import { BackdoorRepository } from '@/model/repository/shift/BackdoorRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): BackdoorRepository => ({
    create(payload) {
      return Repository.post(`${resource}`, payload);
    },
  });
